import request from "@/libs/request";
import { appName } from "../../config/url";

/**
 *  获取用户所用订单信息
 */
export const getUserOrder = (currentPage: string, pageSize: string) => {
    return request({
        url: "/order/user/list",
        method: "get",
        params: {
            current: currentPage,
            pageSize
        }
    });
};

/**
 * 生成订单
 * @param params
 */
export const orderCreate = (params: OrderCreateParams) => {
    params.appName = appName;
    return request({
        url: "/order/create",
        method: "post",
        data: params
    });
};

/**
 * 根据订单ID获取订单信息（包含产品信息等）
 * @param orderId
 */
export const getOrderProducts = (orderId: number) => {
    return request({
        url: "/order/" + orderId,
        method: "get"
    });
};

/**
 * 使用优惠码
 * @param orderId
 * @param promoCode
 */
export const orderUsePromoCode = (orderId: number, promoCode: string) => {
    return request({
        url: "/order/use/",
        method: "post",
        data: { orderId, promoCode }
    });
};

/**
 * 免费开课
 * @param orderId
 */
export const orderFree = (orderId: number) => {
    return request({
        url: "/order/free/" + orderId,
        method: "post"
    });
};

export interface OrderCreateParams {
    orderProducts: OrderCreateProducts[];
    appName: string;
    channel?: string;
}

export interface OrderCreateProducts {
    productId: number;
    initParam?: string;
}
